module.exports = __webpack_public_path__ + "static/media/sonicscale-logo.0c9f63f7.png";